import React, { useState } from 'react'

import { useMeleeContext } from 'draft/context/MeleeContextProvider';

import { GetStageImage } from 'draft/stages/stage'
import { GameType, Stage, StagePack } from 'draft/types';
import { Image } from 'semantic-ui-react'

import meleeLogo from '../assets/melee_logo.webp'
import ultimateLogo from '../assets/ultimate_logo.svg'
import { AppendStageSubList, StageDraftTypes } from 'draft/utils/stageUtils'

const StagesShowcase = () => {
  const meleeContext = useMeleeContext();
  const [gameType, setGameType] = useState<GameType>(meleeContext ? meleeContext?.draftOptions.gameType : GameType.Melee);
  const [stagePack, setStagePack] = useState<StagePack>(meleeContext?.draftOptions.stagePack ?? StagePack.StageMod);

  let competetiveStages: Stage[] = [];
  competetiveStages = AppendStageSubList(StageDraftTypes.STANDARD, competetiveStages, gameType, stagePack);

  let memeStages: Stage[] = [];
  memeStages = AppendStageSubList(StageDraftTypes.MEME, memeStages, gameType, stagePack);


  const printStages = (stages: Stage[]) => (
    stages.map(s => (
      <div className='showcase-item' key={s.Name}>
        <img
          className='melee-stage-img'
          src={GetStageImage(s, gameType)}
          alt={"Stage"}
        />
        <div className='text-container'>
          <h4>{s.Name}</h4>
        </div>
      </div>
    ))
  )

  return (
    <div style={{
      textAlign: 'left',
    }}>
      <h1>Stages</h1>

      <div className='radio-team-container' style={{ justifyContent: 'start' }}>
        <button
          className={`radio-team-button yellow ${gameType === GameType.Melee ? 'selected' : ''}`}
          onClick={() => setGameType(GameType.Melee)}
        >
          <Image size="small" src={meleeLogo} />
        </button>
        <button
          className={`radio-team-button yellow ${gameType === GameType.Ultimate ? 'selected' : ''}`}
          onClick={() => setGameType(GameType.Ultimate)}
        >
          <Image size="small" style={{ filter: "invert(1)" }}
            src={ultimateLogo} />
        </button>
      </div>

      {gameType === GameType.Melee && (
        <div style={{ margin: '1em 0' }}>
          <select
            className='melee-dropdown'
            value={stagePack}
            onChange={(e: any) => setStagePack(e.target.value as StagePack)}
          >
            <option value={StagePack.Standard}>Standard</option>
            <option value={StagePack.StageMod}>Stage Mod</option>
          </select>
        </div>
      )}

      <h2>Competetive</h2>
      <div className={"showcase-container"}>
        {printStages(competetiveStages)}
      </div>

      <h2>Meme</h2>
      <div className={"showcase-container"}>
        {printStages(memeStages)}
      </div>

    </div>
  )
}

export default StagesShowcase;
